import { SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import {
	bondRequestLatestUnderwritingQueryKey,
	bondRequestPreviewsQueryKey,
	bondRequestsQueryKey,
} from "../bond-request.keys";
import { redirectToIssuedBond } from "../utils";

export const useAdminUnderwriteQuote = (accountId: SuretyAccountId, quoteId: SuretyQuoteId) => {
	const { post } = useRequest();
	const queryClient = useQueryClient();

	const mutation = useMutation({
		meta: { redirectOnError: redirectToIssuedBond },
		mutationFn: async () => {
			await post(`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/underwritings`);
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: bondRequestsQueryKey(quoteId) });
			queryClient.invalidateQueries({
				queryKey: bondRequestLatestUnderwritingQueryKey(quoteId),
			});
			queryClient.invalidateQueries({ queryKey: bondRequestPreviewsQueryKey() });
		},
	});

	return {
		underwriteQuote: mutation.mutate,
		underwriteQuoteIsLoading: mutation.isPending,
	};
};
